import { ComponentFactoryResolver, Injectable } from '@angular/core';
import { BookmarksTabComponent } from 'src/app/components/bookmarks/bookmarks-tab/bookmarks-tab.component';
import { ModalService } from 'src/app/modal/modal.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookmarksModalService {

  private isOpenSubject = new BehaviorSubject<boolean>(false);

  public isOpen$ = this.isOpenSubject.asObservable();

  constructor(private modalService: ModalService, private componentFactoryResolver: ComponentFactoryResolver) {
    this.modalService.componentCreationParameters.subscribe(() => {
      if(this.isOpenSubject.getValue())
        this.setOpenState(false);
    });
   }

  public toggle() {
    if(!this.isOpenSubject.getValue()) {
      this.modalService.open({
        componentFactory: this.componentFactoryResolver.resolveComponentFactory(BookmarksTabComponent),
        onInit: (component) => { this.setOpenState(true); }
      });
    }
    else {
      this.modalService.close();
    }
  }

  private setOpenState(state: boolean) {
    this.isOpenSubject.next(state);
  }
}
